import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ItemListComponent } from './item-list/item-list.component';
/*import { ItemComponent } from './ars-billing-code/ars-billing-code.component'*/

import { AuthGuard } from '@core/utilities/auth.guard';
import { RedeploymentAuthorize } from '@core/utilities/redeployment-authorize.guard';
import { Permission } from '@core/literals/permission.literal';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';
import { ItemComponent } from './item/item.component';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: '',
    component: ItemListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewItems, undefined))]
  },
  {
    path: 'Item/Detail/:id',
    component: ItemComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewItems, undefined))]
  },
  {
    path: 'Item/AddToCart/:id',
    component: AddToCartComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewItems, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class ItemsRoutingModule {

}
